import {
    createSelector,
} from '@reduxjs/toolkit';

import {
    calculateSingleSelectionTotalStake,
} from '~Betslip/utils/stakeCalculators';

import {
    selectUserSelections,
} from './userSelectionsSelectors';

import {
    selectParlayTotalStake,
    selectSinglesTotalStake,
} from './parlaySelectors';

import {
    selectAnySelectionSuspended,
} from './selectionDetailsSelectors';

import {
    selectAllFreeBets,
} from './freeBetSelectors';

import {
    selectDisplayFullslip,
} from './uiSelectors';

export const selectSinglesTabTotalStake = createSelector(
    selectUserSelections,
    selectAllFreeBets,
    (userSelections, freebets) => userSelections.reduce(
        (acc, current) => {
            let freebetStake = null;
            if(freebets[current.id]) {
                const selectedFreebet = freebets[current.id].find(currentFreebet => currentFreebet.id === current.free_bet_id);
                freebetStake = selectedFreebet?.value || null;
            }

            return acc + calculateSingleSelectionTotalStake(current, freebetStake);
        }, 0
    )
);

export const selectParlayTabTotalStake = createSelector(
    [
        selectParlayTotalStake,
        selectSinglesTotalStake,
        selectAnySelectionSuspended,
        selectDisplayFullslip,
    ],
    (parlayTotalStake, singlesTotalStake, selectionsSuspended, displayFullslip) => {
        if (selectionsSuspended && displayFullslip) {
            return singlesTotalStake;
        }

        return parlayTotalStake + singlesTotalStake;
    }
);

export const selectBabyStake = state => state.betslip.babyBetslip.stake;
